var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table-column"},[_c('div',{staticClass:"column-title"},[_vm._v(_vm._s(_vm.$t('date.single')))]),_c('div',{staticClass:"column-content"},[_vm._v(" "+_vm._s(_vm.$dt(_vm.ts, _vm.format))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }